import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

var getButtonOptions = function getButtonOptions(props) {
  var buttonProps = {};

  if (props.loading) {
    buttonProps['aria-disabled'] = true;
    buttonProps.clickOnEnter = false;
    buttonProps.clickOnSpace = false;
    buttonProps.focusable = false;
  }

  return _objectSpread(_objectSpread({}, props), buttonProps);
};

export { getButtonOptions };